// libraries and utilities
import { put, call, takeEvery } from "redux-saga/effects";
import { ErrorResponse } from "../../interfaces/ErrorResponse";
import { apiGet, BASE_URL, retrieveToken } from "../../store/api";
import { UserDetailResponse } from "./types";

import * as userActions from "./user.actions";

export function* getDetailUser(
  action: ReturnType<typeof userActions.getDetailUserAsync.request>
) {
  try {
    const token: string = yield retrieveToken();
    const url = `${BASE_URL}users/${action.payload.id}`;
    const result: Response = yield call(apiGet, url, token);

    if (result.status === 200) {
      const parsed: UserDetailResponse = yield call(result.json.bind(result));
      yield put(userActions.getDetailUserAsync.success(parsed));
      return; 
    } else {
      const parsed: ErrorResponse = yield call(result.json.bind(result));
      yield put(userActions.getDetailUserAsync.failure(parsed));
      return;
    }
  } catch (err) {
    const parsed: ErrorResponse = {
      name: 'Internal server error',
      message: 'Internal server error',
      code: 500,
      status: 500
    }
    yield put(userActions.getDetailUserAsync.failure(parsed));
  }
}

export default function* userSagaGetDetailUser() {
  yield takeEvery(userActions.getDetailUserAsync.request, getDetailUser);
}
